"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _arrow_right = _interopRequireDefault(require("../../assets/images/arrow_right.svg"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactSvg = require("react-svg");
var _useTracking2 = require("../../hooks/useTracking");
var FormItem = function FormItem(props) {
  var PREFIX = (0, _getPrefixCls.getPrefixCls)('form-item');
  var value = props.value,
    required = props.required,
    label = props.label,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'horizontal' : _props$layout,
    showArrow = props.showArrow,
    showWordLimit = props.showWordLimit,
    maxLimit = props.maxLimit,
    wordsCount = props.wordsCount,
    fieldName = props.fieldName,
    prompt = props.prompt;
  var _useTracking = (0, _useTracking2.useTracking)({
      trackingData: props.trackingData,
      componentData: {
        fieldId: props.name,
        fieldName: label
      }
    }),
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)(PREFIX, "".concat(PREFIX, "-").concat(layout)),
    onClick: props.onClick
  }, trackingImpressionProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-label")
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: required ? "".concat(PREFIX, "-required") : ''
  }, label), showWordLimit && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(PREFIX, "-limit")
  }, (typeof value === 'string' ? value === null || value === void 0 ? void 0 : value.length : wordsCount) || 0, "/", maxLimit)), prompt && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-prompt")
  }, prompt), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-value")
  }, _react.default.Children.map(props.children, function (child) {
    var _React$cloneElement;
    return /*#__PURE__*/_react.default.cloneElement( /*#__PURE__*/_react.default.isValidElement(child) ? child : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, child), (_React$cloneElement = {}, (0, _defineProperty2.default)(_React$cloneElement, fieldName || 'value', props.value), (0, _defineProperty2.default)(_React$cloneElement, "readOnly", props.readOnly), (0, _defineProperty2.default)(_React$cloneElement, "onChange", props.onChange), _React$cloneElement));
  }), showArrow && /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    className: "".concat(PREFIX, "-arrow"),
    src: _arrow_right.default
  })));
};
exports.FormItem = FormItem;